(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  /*
    Đo chiều cao thật của header đang dính, để thanh lọc bên dưới biết dừng ở đâu.

    Không dùng `--header-height` của theme: nó được đặt một lần trong
    `layout/theme.liquid:404`, và ở lần đo đầu tiên ra 98px trong khi header thật
    cao 113px — chỉ nhảy về đúng sau một lần `resize`. Người dùng bình thường
    không resize cửa sổ, nên với họ giá trị đó vĩnh viễn thiếu 15px và thanh lọc
    chui xuống dưới header đúng 15px đó. Chưa che mất chữ ở cỡ màn hình này,
    nhưng cửa sổ hẹp lại làm menu xuống dòng thì header cao thêm mà con số vẫn
    đứng yên — lúc đó là cắt mất nút.

    Bám vào section nào đang `position: sticky` trong header group, không đếm thứ
    tự con, để thêm/bớt thanh thông báo cũng không sai. Trừ 1px vì header dính ở
    `top: -1px`; không trừ thì hở một sọc và ảnh sản phẩm chạy qua khe đó.
  */
  (function () {
    const group = document.querySelector('#header-group');
    if (!group) return;

    const header = Array.from(group.querySelectorAll(':scope > .shopify-section')).find(
      (section) => getComputedStyle(section).position === 'sticky'
    );
    if (!header) return;

    const apply = function () {
      const height = Math.round(header.getBoundingClientRect().height);
      document.body.style.setProperty('--pf-sticky-top', height - 1 + 'px');
    };

    apply();
    new ResizeObserver(apply).observe(header);
  })();

  } catch(e) { console.error(e); }
})();
})();
